<template lang="pug">
transition(name="fade", mode="out-in", appear)
  .text-center(v-if="loading", key="loader")
    v-progress-circular(:size="64", color="blue-grey", indeterminate)

  .pt-4.pb-16(v-else, key="content")
    v-snackbar(
      bottom,
      :elevation="24",
      :timeout="snackbar.timeout",
      :color="snackbar.color",
      v-model="snackbar.value"
    )
      .overline {{ snackbar.text }}
      template(v-slot:action="{ attrs }")
        v-btn(icon, dark, v-bind="attrs", @click="snackbar.value = false")
          v-icon mdi-close

    .pl-2.d-flex.align-center
      h2.h2.pr-2 Categories

      v-btn(icon, @click="add('category', categories)")
        v-icon mdi-plus

      v-spacer

      v-dialog(v-model="dialog", width="500")
        template(v-slot:activator="{ on, attrs }")
          v-btn.mr-2(v-on="on", v-bind="attrs", color="secondary") Restore
        v-card
          v-card-title.headline.grey.lighten-2
            | Are you sure?
          v-card-text.pa-6
            | All changes will be lost.
          v-divider
          v-card-actions
            v-spacer
            v-btn(text, color="secondary", @click="dialog = false") Cancel
            v-btn(
              text,
              color="error",
              @click="getCategories(); dialog = false"
            ) Yes

      v-btn(color="primary", :disabled="!acceptable", @click="save") Save

    transition-group(name="list", tag="div")
      .d-flex.flex-column.list-item(
        v-for="(category, i) in categories",
        :key="category.key"
      )
        .pt-4.d-flex.align-center
          v-btn(
            icon,
            :disabled="category.isExpanded && !category.subs.length",
            @click="category.isExpanded = !category.isExpanded"
          )
            v-icon(
              :class="{ 'rotate-90': category.isExpanded }",
              style="transition-duration: 0.2s"
            ) mdi-chevron-right

          .px-2.d-flex.flex-column.align-center
            v-btn(icon, :disabled="!i", @click="move(categories, i, 'up')")
              v-icon mdi-chevron-up

            v-btn(
              icon,
              :disabled="i === categories.length - 1",
              @click="move(categories, i, 'down')"
            )
              v-icon mdi-chevron-down

          .pr-2.text-right(style="width: 36px") {{ i + 1 }}.

          .flex-1.pa-2
            v-text-field(
              :id="[category.key, 'title'].join('-')",
              dense,
              outlined,
              hide-details,
              label="Title",
              placeholder="Category title",
              :rules="[rules.filled]",
              v-model="category.title"
            )

          v-dialog(v-model="category.dialog", width="500")
            template(v-slot:activator="{ on, attrs }")
              v-btn(v-on="on", v-bind="attrs", icon)
                v-icon(color="red darken-1") mdi-delete

            v-card
              v-card-title.headline.grey.lighten-2
                | Are you sure?

              v-card-text.pa-6
                | Selected category will be permanently deleted.

              v-divider

              v-card-actions
                v-spacer

                v-btn(
                  text,
                  color="secondary",
                  @click="category.dialog = false"
                ) Cancel

                v-btn(
                  text,
                  color="error",
                  @click="remove(categories, i); category.dialog = false"
                ) Delete

        v-expand-transition
          .pl-10(v-if="category.isExpanded")
            .pt-4.pl-2.d-flex.align-center
              h2.h2.pr-2 Sub-categories

              v-btn(icon, @click="add('sub', category.subs)")
                v-icon mdi-plus

            transition-group.d-flex.flex-column(name="list", tag="div")
              .pt-4.list-item(
                v-for="(sub, j) in category.subs",
                :key="sub.key"
              )
                .d-flex.align-center
                  v-btn(
                    icon,
                    :disabled="sub.isExpanded && !sub.items.length",
                    @click="sub.isExpanded = !sub.isExpanded"
                  )
                    v-icon(
                      :class="{ 'rotate-90': sub.isExpanded }",
                      style="transition-duration: 0.2s"
                    ) mdi-chevron-right

                  .px-2.d-flex.flex-column.align-center
                    v-btn(
                      icon,
                      :disabled="!j",
                      @click="move(category.subs, j, 'up')"
                    )
                      v-icon mdi-chevron-up

                    v-btn(
                      icon,
                      :disabled="j === category.subs.length - 1",
                      @click="move(category.subs, j, 'down')"
                    )
                      v-icon mdi-chevron-down

                  .pr-2.text-right(style="width: 36px") {{ j + 1 }}.

                  .flex-1.pa-2
                    v-text-field(
                      :id="[category.key, sub.key, 'title'].join('-')",
                      dense,
                      outlined,
                      hide-details,
                      label="Title",
                      placeholder="Sub-category title",
                      v-model="sub.title"
                    )

                  v-dialog(v-model="sub.dialog", width="500")
                    template(v-slot:activator="{ on, attrs }")
                      v-btn(v-on="on", v-bind="attrs", icon)
                        v-icon(color="red darken-1") mdi-delete

                    v-card
                      v-card-title.headline.grey.lighten-2
                        | Are you sure?

                      v-card-text.pa-6
                        | Selected sub will be permanently deleted.

                      v-divider

                      v-card-actions
                        v-spacer

                        v-btn(
                          text,
                          color="secondary",
                          @click="sub.dialog = false"
                        ) Cancel

                        v-btn(
                          text,
                          color="error",
                          @click="remove(category.subs, j); sub.dialog = false"
                        ) Delete

                v-expand-transition
                  .pl-10(v-if="sub.isExpanded")
                    .pt-4.pl-2.d-flex.align-center
                      h2.h2.pr-2 Questions

                      v-btn(icon, @click="add('item', sub.items)")
                        v-icon mdi-plus

                    transition-group.d-flex.flex-column(name="list", tag="div")
                      .pl-10.pt-4.list-item(
                        v-for="(item, k) in sub.items",
                        :key="item.key"
                      )
                        .d-flex.align-center
                          .px-2.d-flex.flex-column.align-center
                            v-btn(
                              icon,
                              :disabled="!k",
                              @click="move(sub.items, k, 'up')"
                            )
                              v-icon mdi-chevron-up

                            v-btn(
                              icon,
                              :disabled="k === sub.items.length - 1",
                              @click="move(sub.items, k, 'down')"
                            )
                              v-icon mdi-chevron-down

                          .pr-2.text-right(style="width: 36px") {{ k + 1 }}.

                          .flex-1.d-flex.flex-column
                            .pa-2
                              v-text-field(
                                :id="[category.key, sub.key, item.key, 'label'].join('-')",
                                dense,
                                outlined,
                                hide-details,
                                label="Label",
                                placeholder="Item label",
                                :rules="[rules.filled]",
                                v-model="item.label"
                              )

                            .pa-2
                              v-text-field(
                                :id="[category.key, sub.key, item.key, 'alias'].join('-')",
                                dense,
                                outlined,
                                hide-details,
                                label="Alias",
                                placeholder="Item alias",
                                :rules="[rules.filled]",
                                v-model="item.alias"
                              )

                          v-dialog(v-model="item.dialog", width="500")
                            template(v-slot:activator="{ on, attrs }")
                              v-btn(v-on="on", v-bind="attrs", icon)
                                v-icon(color="red darken-1") mdi-delete

                            v-card
                              v-card-title.headline.grey.lighten-2
                                | Are you sure?

                              v-card-text.pa-6
                                | Selected item will be permanently deleted.

                              v-divider

                              v-card-actions
                                v-spacer

                                v-btn(
                                  text,
                                  color="secondary",
                                  @click="item.dialog = false"
                                ) Cancel

                                v-btn(
                                  text,
                                  color="error",
                                  @click="remove(sub.items, k); item.dialog = false"
                                ) Delete
</template>

<script>
const uniqueKeys = [];

const random = (min, max) => {
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
};

const generateKey = () => {
  const key = random(100, 9998);
  if (uniqueKeys.includes(key)) return generateKey();
  else {
    uniqueKeys.push(key);
    return key;
  }
};

const rules = {
  filled: (v) => !!v || "",
  databased: (v) => /[a-zA-Z\d][\w#@]{0,127}$/.test(v) || "",
};

export default {
  name: "online-application",

  data: () => ({
    reqCount: 0,
    categories: [],
    dialog: false,
    snackbar: {
      timeout: 3000,
      color: "",
      text: "",
      value: false,
    },
    rules,
  }),

  computed: {
    loading() {
      return !!this.reqCount;
    },

    acceptable() {
      return this.categories.every(
        (category) =>
          rules.filled(category.title) === true &&
          category.subs.every((sub) =>
            sub.items.every((item) =>
              [item.label, item.alias].every((el) => rules.filled(el) === true)
            )
          )
      );
    },
  },

  methods: {
    getCategories() {
      this.reqCount += 1;
      this.axios
        .get("/admin/online_app")
        .then((resp) => this.prepareCategories(resp.data))
        .catch(() => {
          this.categories = [];
          this.snackbar.color = "error";
          this.snackbar.text = "Something went wrong!";
          this.snackbar.value = true;
        })
        .finally(() => (this.reqCount -= 1));
    },

    prepareCategories(categories) {
      this.categories = categories.map((category) => ({
        ID: category.ID,
        key: generateKey(),
        dialog: false,
        isExpanded: false,
        title: category.title,
        subs: category.subs.map((sub) => ({
          ID: sub.ID,
          key: generateKey(),
          dialog: false,
          isExpanded: false,
          title: sub.title,
          items: sub.items.map((item) => ({
            ID: item.ID,
            key: generateKey(),
            dialog: false,
            label: item.label,
            alias: item.alias,
          })),
        })),
      }));
    },

    move(array, from, direction) {
      let to = from;
      switch (direction) {
        case "up":
          if (from) to -= 1;
          break;
        case "down":
          if (from + 1 !== array.length) to += 1;
          break;
      }
      array.splice(to, 0, array.splice(from, 1)[0]);
    },

    remove(array, index) {
      array.splice(index, 1);
    },

    add(type, array) {
      let el;
      switch (type) {
        case "category":
          el = {
            ID: 0,
            key: generateKey(),
            dialog: false,
            isExpanded: true,
            title: "",
            subs: [],
          };
          break;
        case "sub":
          el = {
            ID: 0,
            key: generateKey(),
            dialog: false,
            isExpanded: true,
            title: "",
            items: [],
          };
          break;
        case "item":
          el = {
            ID: 0,
            key: generateKey(),
            dialog: false,
            title: "",
            items: [],
          };
          break;
      }
      array.push(el);
    },

    save() {
      this.reqCount += 1;
      const data = this.categories.map((category) => ({
        ID: category.ID,
        title: category.title,
        subs: category.subs.map((sub) => ({
          ID: sub.ID,
          title: sub.title,
          items: sub.items.map((item) => ({
            ID: item.ID,
            label: item.label,
            alias: item.alias,
          })),
        })),
      }));
      this.axios
        .put("/admin/online_app", data)
        .then((resp) => {
          this.prepareCategories(resp.data);
          this.$message.success("All changes were succesfully saved!");
        })
        .catch((err) => {
          this.$message.errorFromServer(err);
        })
        .finally(() => {
          this.snackbar.value = true;
          this.reqCount -= 1;
        });
    },
  },

  created() {
    this.getCategories();
  },
};
</script>

<style lang="sass" scoped>
.flex-1
  flex: 1

.rotate-90
  transform: rotate(90deg)

.list
  &-item
    transition: 0.2s
    display: inline-block
  &-enter, &-leave-to
    opacity: 0
    transform: translateX(100%)
  &-leave-active
    position: absolute
</style>